import React from 'react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { MOCKUP_IMAGES } from '../data/content';
export function FinalCTA() {
  return <section className="w-full bg-navy-900 px-4 py-12 sm:px-6 sm:py-16" data-id="element-116" data-mp="3ueqawvnj897q">
      <div className="mx-auto max-w-2xl text-center" data-id="element-117" data-mp="c83pxlftno62">
        <h2 className="font-serif text-[28px] font-bold leading-tight text-white sm:text-4xl" data-id="element-118" data-mp="84xl8i8cy51p">
          ¿Estás listo para dejar de improvisar y comenzar a seguir una{' '}
          <span className="italic text-teal" data-id="element-119" data-mp="h5vdk39foo4g">Ruta Clínica</span>?
        </h2>
        <p className="mt-5 text-[15px] leading-relaxed text-navy-100" data-id="element-120" data-mp="h3rebymhcdai">
          La próxima vez que un paciente te pregunte si es candidato a un
          GLP-1... no tendrás que abrir cinco guías, buscar un artículo o dudar
          frente a la pantalla.
        </p>
        <p className="mt-3 text-[16px] font-bold text-white" data-id="element-121" data-mp="14w7v85uhdz88">
          Sabrás exactamente cuál es el siguiente paso.
        </p>
        <p className="mt-3 text-[14.5px] leading-relaxed text-teal" data-id="element-122" data-mp="zua64uzega7d">
          Porque eso es lo que hace una Ruta Clínica: convierte la incertidumbre
          en decisiones clínicas claras.
        </p>

        <img src={MOCKUP_IMAGES.bundle} alt="Paquete completo Ruta Clínica GLP-1 con 6 tomos y 5 bonos" className="mx-auto mt-8 w-full max-w-sm" loading="lazy" data-id="element-123" data-mp="2h5u6p28dj8jf" />

        <div className="mx-auto mt-4 max-w-md" data-id="element-124" data-mp="2v3iou2b241ks">
          <CTAButton label="Quiero la Ruta Clínica por USD $15" size="lg" pulse note="Descarga inmediata • Acceso de por vida • Garantía de 7 días" noteClassName="text-navy-100" data-id="element-125" data-mp="2v2r4jnmwtq9t" />
        </div>

        <div className="mx-auto mt-6 max-w-md text-left" data-id="element-126" data-mp="39s5dwvqhk7p7">
          <Countdown data-id="element-127" data-mp="39rn8p9luij55" />
        </div>
      </div>
    </section>;
}